import Jamie from '@lib/core/src/assets/jamie.png';
import palette from '@lib/core/src/theme/palette';
import { Stack, Typography, Avatar, styled } from '@mui/material';

import useLoginContext from '@/context/LoginFlowContextProvider/useLoginContext';
import useGreeting from '@/hooks/useGreeting';

const GreetingText = styled(Typography)({
  fontSize: '22px',
  lineHeight: '24px',
  fontWeight: 600,
  color: palette.black
});

const GreetingAvatar = styled(Avatar)({
  width: 40,
  height: 40,
  marginRight: '12px'
});

const GreetingStack = styled(Stack)({
  flexDirection: 'row',
  alignItems: 'center'
});

const Greeting = () => {
  const { currentUser } = useLoginContext();
  const greeting = useGreeting();
  return (
    <GreetingStack>
      <GreetingAvatar alt="Jamie: " src={Jamie} />
      <GreetingText>{`${greeting}${currentUser?.firstName ? `, ${currentUser?.firstName}!` : ''}`}</GreetingText>
    </GreetingStack>
  );
};

export default Greeting;
